"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAssetTypesForIVRProduct = exports.LOAN_ASSET_TYPE_TO_IVR_PRODUCT = exports.IVRProduct = exports.AvenProducts = exports.LOAN_ASSET_TYPE_TO_AVEN_PRODUCT = exports.AvenProductOrUnknown = void 0;
const asset_1 = require("./origination/asset");
/** @TranslateToPython */
var AvenProductOrUnknown;
(function (AvenProductOrUnknown) {
    AvenProductOrUnknown["HOME"] = "HOME";
    AvenProductOrUnknown["UCC"] = "UCC";
    AvenProductOrUnknown["MORTGAGE"] = "MORTGAGE";
    AvenProductOrUnknown["DEPOSIT"] = "DEPOSIT";
    AvenProductOrUnknown["ADVISOR"] = "ADVISOR";
    // Currently not live or being worked on:
    AvenProductOrUnknown["AUTO"] = "AUTO";
    AvenProductOrUnknown["CRYPTO"] = "CRYPTO";
    // Special case where we don't have context to derive the product; 99% this is used on lead person payloads
    AvenProductOrUnknown["UNKNOWN"] = "UNKNOWN";
})(AvenProductOrUnknown || (exports.AvenProductOrUnknown = AvenProductOrUnknown = {}));
// Maps each LoanAssetType to its corresponding AvenProduct.
// This is the single source of truth for asset-type-to-product mapping.
/** @TranslateToPython */
exports.LOAN_ASSET_TYPE_TO_AVEN_PRODUCT = {
    [asset_1.LoanAssetType.auto]: AvenProductOrUnknown.AUTO,
    [asset_1.LoanAssetType.crypto]: AvenProductOrUnknown.CRYPTO,
    [asset_1.LoanAssetType.deposit]: AvenProductOrUnknown.DEPOSIT,
    [asset_1.LoanAssetType.personalPropertyAttestation]: AvenProductOrUnknown.UCC,
    [asset_1.LoanAssetType.homeMortgage]: AvenProductOrUnknown.MORTGAGE,
    [asset_1.LoanAssetType.home_no_loyalty]: AvenProductOrUnknown.HOME,
    [asset_1.LoanAssetType.home]: AvenProductOrUnknown.HOME,
};
exports.AvenProducts = [
    AvenProductOrUnknown.ADVISOR,
    AvenProductOrUnknown.AUTO,
    AvenProductOrUnknown.CRYPTO,
    AvenProductOrUnknown.DEPOSIT,
    AvenProductOrUnknown.HOME,
    AvenProductOrUnknown.MORTGAGE,
    AvenProductOrUnknown.UCC,
];
// IVR products used by Amazon Connect routing. Each value represents a separate call funnel.
var IVRProduct;
(function (IVRProduct) {
    IVRProduct["Credit"] = "Credit";
    IVRProduct["Deposit"] = "Deposit";
})(IVRProduct || (exports.IVRProduct = IVRProduct = {}));
exports.LOAN_ASSET_TYPE_TO_IVR_PRODUCT = {
    [asset_1.LoanAssetType.home]: IVRProduct.Credit,
    [asset_1.LoanAssetType.home_no_loyalty]: IVRProduct.Credit,
    [asset_1.LoanAssetType.homeMortgage]: IVRProduct.Credit,
    [asset_1.LoanAssetType.personalPropertyAttestation]: IVRProduct.Credit,
    [asset_1.LoanAssetType.crypto]: IVRProduct.Credit,
    [asset_1.LoanAssetType.auto]: IVRProduct.Credit,
    [asset_1.LoanAssetType.deposit]: IVRProduct.Deposit,
};
const getAssetTypesForIVRProduct = (ivrProduct) => Object.values(asset_1.LoanAssetType).filter((assetType) => exports.LOAN_ASSET_TYPE_TO_IVR_PRODUCT[assetType] === ivrProduct);
exports.getAssetTypesForIVRProduct = getAssetTypesForIVRProduct;
